import { render, staticRenderFns } from "./IndicadoresResumoExterna.vue?vue&type=template&id=1d53d0e5&scoped=true&"
import script from "./IndicadoresResumoExterna.vue?vue&type=script&lang=js&"
export * from "./IndicadoresResumoExterna.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresResumoExterna.vue?vue&type=style&index=0&id=1d53d0e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d53d0e5",
  null
  
)

export default component.exports